import 'waypoints/lib/noframework.waypoints.min';

class ProductStickyButton {
  constructor() {
    this.stickyBookBtn = document.querySelector('[data-sticky-book-btn]');
    this.productBookBox = document.querySelector('[data-product-book-box]');
    this.siteFooter = document.querySelector(
      '[data-site-footer-waypoint-element]'
    );
    this.init();
  }

  stickyButtonHandler() {
    this.stickyBookBtn.classList.toggle('active');
  }

  init() {
    if (this.stickyBookBtn) {
      new Waypoint({
        element: this.productBookBox,
        handler: () => this.stickyButtonHandler(),
        offset: '-25%',
      });
      new Waypoint({
        element: this.siteFooter,
        handler: () => this.stickyButtonHandler(),
        offset: '100%',
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new ProductStickyButton());
